export default __webpack_public_path__ + "pgnv-assets/798269813169a66231469904ee38147f.png";